'use strict';

var makeStyles = require('../../node_modules/@material-ui/core/esm/styles/makeStyles.js');

var useKanbanCardStyles = makeStyles(function (theme) {
  return {
    card: {
      border: function border(props) {
        return props.cardBorder;
      },
      width: 278,
      height: 168,
      '&.small': {
        width: 190
      },
      '&.large': {
        width: 358
      }
    },
    cardHeader: {
      cursor: 'move',
      padding: 4,
      '& .headerActions': {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        flexWrap: 'no-wrap',
        '& .left': {
          alignSelf: 'flex-start'
        },
        '& .right': {
          alignSelf: 'flex-end',
          marginLeft: 'auto'
        },
        '& button': {
          padding: 8
        },
        '&.empty': {
          height: 40
        }
      }
    },
    cardContent: {
      margin: 0,
      padding: '6px 16px',
      '& p, & div': {
        margin: 0,
        padding: 0
      }
    },
    cardActionArea: {
      borderRadius: '0 0 8px 8px'
    },
    cardFooter: {
      background: function background(props) {
        return props.footerBackgroundColor;
      },
      borderLeft: function borderLeft(props) {
        return props.cardBorder;
      },
      borderRight: function borderRight(props) {
        return props.cardBorder;
      },
      borderBottom: function borderBottom(props) {
        return props.cardBorder;
      },
      position: 'relative',
      top: 2,
      borderRadius: '0 0 8px 8px',
      margin: '1px -1px',
      padding: '9px 12px 7px 12px',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      '& .footer-adornment': {
        marginRight: -2,
        '& svg': {
          position: 'relative',
          top: 2
        }
      },
      '&.noFooter': {
        height: 44,
        background: 'white'
      }
    }
  };
});

module.exports = useKanbanCardStyles;
